<template>
  <div>
    <el-dialog title="渠道管理" :visible.sync="dialogVisible" width="800px">
      <el-table :data="tableData" v-loading="loading" border style="width: 100%" max-height="750">
        <el-table-column type="index" label="显示顺序" align="center" min-width="120"> </el-table-column>
        <el-table-column prop="channelName" label="渠道名称" align="center" min-width="120">
          <template #default="scope">
            <div v-if="!scope.row.showInput">{{ scope.row.channelName }}</div>
            <el-input v-model="scope.row.channelName" v-if="scope.row.showInput"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="updatedBy" label="变更人" align="center" min-width="120">
          <template #default="scope">
            <div v-if="!scope.row.showInput">{{ scope.row.updatedBy }}</div>
            <!-- <el-input v-model="scope.row.updatedBy" v-if="scope.row.showInput"></el-input> -->
          </template>
        </el-table-column>
        <el-table-column prop="updatedTime" label="变更时间" align="center" min-width="140">
          <template #default="scope">
            <div v-if="!scope.row.showInput">{{ scope.row.updatedBy }}</div>
            <!-- <el-input v-model="scope.row.updatedTime" v-if="scope.row.showInput"></el-input> -->
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template #default="scope">
            <div class="operate">
              <div v-if="!scope.row.showInput" class="btn" @click="up(scope.row)">上移</div>
              <div v-if="!scope.row.showInput" class="btn" @click="down(scope.row)">下移</div>
              <el-popconfirm v-if="!scope.row.showInput" title="是否删除这一条数据？" @confirm="deleteOnly(scope.row)">
                <div slot="reference" class="btn">删除</div>
              </el-popconfirm>
              <div v-if="scope.row.showInput" class="btn" @click="save(scope.row)">保存</div>
              <div v-if="scope.row.showInput" class="btn" @click="cancel(scope)">取消</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4" >
        <div class="addContent" @click="addTableTiem">
          <i class="el-icon-plus"></i>
          <div class="add">添加</div>
        </div>
      </div>
      <div class="pageContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageData.page" :page-sizes="[20, 40, 60, 80, 100]" :page-size="pageData.pageSize" layout="total, prev, pager, next,sizes" :total="total"> </el-pagination>
      </div>
      <!-- <div class="footerBtn">
        <el-button @click="cancelBtn()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "channel",
  data() {
    return {
      dialogVisible: false,
      show: true,
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      value: ""
    };
  },
  mounted() {
    // this.$bus.$on("channel", res => {
    //   this.dialogVisible = res;
    // });
    // this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      this.loading = true;
      apis.liveChannelPageList(this.pageData).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    // 添加
    addTableTiem() {
      this.tableData.forEach((item, index) => {
        if (!item.channelName) {
          this.tableData.splice(index, 1);
        }
      });
      this.show = false;
      this.tableData.push({
        channelName: "",
        updatedBy: "",
        updatedTime: "",
        showInput: true
      });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getTableData();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getTableData();
    },
    // 上移 下移 接口
    sortData(data) {
      apis.liveAddAndEditChannel(data).then(res => {
        if (res.code === 200) {
          const msg = data.sortName === "up" ? "上移" : "下移";
          this.$message({
            message: `${msg}成功`,
            type: "success"
          });
          this.getTableData();
        }
      });
    },
    // 上移
    up(row) {
      const json = {
        id: row.id,
        channelName: row.channelName,
        sortName: "up"
      };
      this.sortData(json);
    },
    // 下移
    down(row) {
      const json = {
        id: row.id,
        channelName: row.channelName,
        sortName: "down"
      };
      this.sortData(json);
    },
    // 删除
    deleteOnly(row) {
      apis.liveDeteleChannel(row.id).then(res => {
        if (res.code === 200) {
          this.getTableData();
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    },
    save(row) {
      if (row.channelName) {
        apis.liveAddAndEditChannel({ channelName: row.channelName }).then(res => {
          if (res.code === 200) {
            this.getTableData();
            this.$message({
              message: "保存成功",
              type: "success"
            });
          }
        });
      } else {
        this.$message({
          message: "请输入渠道名称",
          type: "warning"
        });
        return;
      }
    },
    cancel(scope) {
      this.tableData.splice(scope.$index, 1);
      this.$message({
        message: "取消成功",
        type: "success"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
.mt-4 {
  width: 100%;
  color: #008754;
  border: 1px solid #dde3df;
  border-top: 0;
  height: 84px;
  margin-top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .addContent {
    display: flex;

    align-items: center;
    .add {
      margin: 0 80px 0 15px;
    }
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.footerBtn {
  margin-top: 20px;
  text-align: center;
}
</style>
